module.exports = __webpack_public_path__ + "media/images/ADDress_logo-adaa63ba94f0645e0437ce16ace564fb.jpeg";